import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule, provideZonelessChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from '@core/core.module';
import { AuthInterceptor } from '@core/interceptor/auth.interceptor';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FormatModule } from '@shared/format/format.module';
import { ModalModule } from '@shared/modal/modal.module';
import { SpinnerModule } from '@shared/spinner/spinner.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ROOT_REDUCERS, metaReducers } from './store';
import { ToastContainerComponent } from '@shared/toast/component/toast-container.component';

registerLocaleData(localeFr);

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    ReactiveFormsModule,
    ModalModule,
    SpinnerModule,
    FormatModule,
    ToastContainerComponent,
    StoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers,
      runtimeChecks: {
        strictStateSerializability: true,
        strictActionTypeUniqueness: true
      }
    }),
    EffectsModule.forRoot(),
    StoreRouterConnectingModule.forRoot(),
    environment.env === 'local' || environment.env === 'plg'
      ? StoreDevtoolsModule.instrument({
          name: 'SMG',
          maxAge: 25,
          actionsBlocklist: ['NOOP', '[Core] Show spinner', '[Core] Hide spinner']
        })
      : [],
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.env !== 'local',
      registrationStrategy: 'registerImmediately'
    })
  ],
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
